import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardMedia from './card-media';
import Button from '../buttons/button';

import './style.scss';

const Card = ({ children, media, header, footer, onHover, onClick }) => {
  const cardClasses = classNames('uni-card', { 'uni-card--has-hover': onHover, 'uni-card--has-footer': footer });

  return (
    <div className={cardClasses} onMouseEnter={onHover} onClick={onClick}>
      {media && <CardMedia style={{ marginTop: '-1rem', marginBottom: '0.5rem' }}>{media}</CardMedia>}

      {header && <div className="uni-card__header">{header}</div>}

      <div className="uni-card__body">{children}</div>

      {footer && (
        <div className="uni-card__footer">
          {footer.map((item, key) => (
            <Button
              size="medium"
              style="minimal"
              type={item.type}
              disabled={item.disabled}
              icon={item.icon}
              data-qa-id={item.qaId}
              buttonRef={item.actionRef}
              onClick={item.onClick}
              key={key}
            >
              {item.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  media: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      disabled: PropTypes.bool,
      qaId: PropTypes.string,
      actionRef: PropTypes.func,
      onClick: PropTypes.func.isRequired,
    })
  ),
  onHover: PropTypes.func,
  onClick: PropTypes.func,
};

export default Card;



// WEBPACK FOOTER //
// ./src/card/index.jsx